import { Typography, useTheme } from '@mui/material';
import DOMPurify from 'dompurify';
import { useContext } from 'react';
import get from 'lodash/get';
import { formatMessage, formatPriceWithVatRate } from '../../utils/strings';
import PricesContext from './PricesContext';

const additionalStyles = {
  h2: {
    mt: 4,
  },
  h3: {
    mt: 2,
  },
  subtitle1: {
    mt: 0,
    fontWeight: 'bold',
  },
  subtitleFaq: {
    pb: 3,
  },
};

const Text = props => {
  const theme = useTheme();
  const { domesticPrices } = useContext(PricesContext);
  const text = props.priceKey
    ? formatMessage(
        props.text,
        formatPriceWithVatRate(
          get(domesticPrices, props.priceKeyWithVatRate),
          get(domesticPrices, props.priceKey)
        )
      )
    : props.text;

  return (
    <Typography
      sx={{
        '& a': {
          color: theme.vars.palette.primary.main,
        },
        pb: 1,
        ...additionalStyles[props.variant],
      }}
      {...props}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(text, {
          ALLOWED_ATTR: ['href', 'referrerpolicy', 'target'],
        }),
      }}
    />
  );
};

export default Text;
